"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'gelede',
  suffixFromNow: 'van nou af',
  second: '1 sekonde',
  seconds: '%d sekondes',
  minute: '1 minuut',
  minutes: '%d minute',
  hour: '1 uur',
  hours: '%d ure',
  day: '1 dag',
  days: '%d dae',
  month: '1 maand',
  months: '%d maande',
  year: '1 jaar',
  years: '%d jaar',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;